module.exports = __webpack_public_path__ + "static/media/S (78).c88cff8e.jpg";